import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { QualifierValue } from "../internal/qualifier/QualifierValue.js";
/**
 * @summary qualifier
 * @namespace AutoFocus
 * @memberOf Qualifiers
 * @see Visit {@link Qualifiers.Gravity|Gravity} for an example
 */

/**
 * @memberOf Qualifiers.AutoFocus
 * @extends {SDK.QualifierValue}
 * @see Visit {@link Qualifiers.Gravity|Gravity} for an example
 */

var AutoFocus = /*#__PURE__*/function (_QualifierValue) {
  _inherits(AutoFocus, _QualifierValue);

  var _super = _createSuper(AutoFocus);

  function AutoFocus(focusOn, weight) {
    var _this;

    _classCallCheck(this, AutoFocus);

    _this = _super.call(this);
    _this._weight = weight;
    _this.focusOn = focusOn;
    _this.shouldAvoid = false;
    return _this;
  }
  /**
   * @summary qualifier
   * @description Specifies the object to focus on automatically
   * Accepts an AutoFocusObject (which is just a wrapper for a FocusOn object, but with extra method: avoid, weight)
   * @param {Qualifiers.FocusOn} obj The object to focus on.
   * @param {number} weight
   */


  _createClass(AutoFocus, [{
    key: "shouldAddWeight",
    value: function shouldAddWeight() {
      return typeof this._weight === 'number' || typeof this._weight === 'string' || this.shouldAvoid;
    }
    /**
     * @summary qualifier
     * @desc Get the name of the of the object
     */

  }, {
    key: "getName",
    value: function getName() {
      return this.focusOn.name;
    }
    /**
     * @summary qualifier
     * @desc Get the weight for the object
     */

  }, {
    key: "getWeight",
    value: function getWeight() {
      if (this.shouldAvoid) {
        return 'avoid';
      } else {
        return this._weight;
      }
    }
    /**
     * @summary qualifier
     * @desc Return the string representation of this QualifierValue
     */

  }, {
    key: "toString",
    value: function toString() {
      // Future proofing, in case we'd like to support some custom string in the future, or if data is coming from a DB
      if (this.shouldAddWeight()) {
        return "".concat(this.getName(), "_").concat(this.getWeight());
      } else {
        return "".concat(this.getName());
      }
    }
    /**
     * @summary qualifier
     * @description Sets the importance level of the object within the automatic gravity algorithm
     * @param {numebr} w The focus weight for the object
     * @return {this}
     */

  }, {
    key: "weight",
    value: function weight(w) {
      this._weight = w;
      return this;
    }
    /**
     * @summary qualifier
     * @description Attempts to avoid the detected object in the image
     * @return {this}
     */

  }, {
    key: "avoid",
    value: function avoid() {
      this.shouldAvoid = true;
      return this;
    }
  }], [{
    key: "focusOn",
    value: function focusOn(obj, weight) {
      return new AutoFocus(obj, weight);
    }
  }]);

  return AutoFocus;
}(QualifierValue);

export { AutoFocus };